module.exports = __webpack_public_path__ + "img/servicio.41296258.png";